import { render, staticRenderFns } from "./ListBonChargeReg.vue?vue&type=template&id=4518e6cd&scoped=true&"
import script from "./ListBonChargeReg.vue?vue&type=script&lang=js&"
export * from "./ListBonChargeReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518e6cd",
  null
  
)

export default component.exports